import { metadata as ActionNodeMetadata } from './nodes/action-node/action.node.tsx'
import { metadata as ConditionNodeMetadata } from './nodes/condition-node/condition.node'
import { metadata as EndNodeMetadata } from './nodes/end.node'
import { metadata as FlowConnectionNodeMetadata } from './nodes/flow-connection-node/flow-connection.node'
import { metadata as IntegrationNodeMetadata } from './nodes/integration-node/integration.node'
import { metadata as MenuNodeMetadata } from './nodes/menu-node/menu.node'
import { metadata as RandomizerNodeMetadata } from './nodes/randomizer-node/randomizer.node'
import { metadata as StartNodeMetadata } from './nodes/start.node'
import { metadata as TextMessageNodeMetadata } from './nodes/text-message-node/text-message.node'
import { BuilderNodeType, RegisterNodeMetadata } from './types'

export const NODES: RegisterNodeMetadata[] = [
  StartNodeMetadata,
  TextMessageNodeMetadata,
  MenuNodeMetadata,
  ActionNodeMetadata,
  ConditionNodeMetadata,
  FlowConnectionNodeMetadata,
  RandomizerNodeMetadata,
  IntegrationNodeMetadata,
  EndNodeMetadata,
]

export const NODE_TYPES = NODES.reduce(
  (acc, { type, node }) => {
    acc[type] = node
    return acc
  },
  {} as Record<string, any>
)

export const NODES_METADATA = NODES.reduce(
  (acc, current) => {
    acc[current.type] = {
      ...current,
      __details: { type: current.type, ...current.detail },
    }
    return acc
  },
  {} as Record<
    BuilderNodeType,
    RegisterNodeMetadata & {
      __details: {
        type: RegisterNodeMetadata['type']
      } & RegisterNodeMetadata['detail']
    }
  >
)

export const AVAILABLE_NODES = NODES.filter(
  (node) => node.available === undefined || node.available
).map((node) => ({
  type: node.type,
  icon: node.detail.icon,
  title: node.detail.title,
  description: node.detail.description,
  gradientColor: node.detail.gradientColor,
}))
